<template>
  <div class="content-block">
    <h1>Imprint</h1>
    <p>
      This site is made and run by Merten Hanisch<br>
      Contact:
      <a href="mailto:merten.hanisch@gmail.com">merten.hanisch@gmail.com</a>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'imprint'
  }
</script>



// WEBPACK FOOTER //
// imprint.vue?1c19a561